import { UserType } from '@kijiji/generated/graphql-types'

export const isFSBBUser = (userType?: UserType | null) => {
  return (
    userType === UserType.Professional ||
    userType === UserType.ReProfessional ||
    userType === UserType.RetailProfessional ||
    userType === UserType.JobsProfessional
  )
}
